import React from "react";

export function ScheduledPriceIncreaseInfo({ orderDetail, title }) {
  const {
    is_price_scheduled,
    original_unit_price,
    price_increase_by_amount,
    p_increase_mail_date,
    price_increase_schedule_date,
  } = orderDetail;

  const titleText = is_price_scheduled
    ? "The POD price was increased as scheduled."
    : "The POD price increase is scheduled.";

  const paragraphText = is_price_scheduled ? (
    <p>
      The subscription price <strong>increased</strong> from <strong>£{original_unit_price}</strong> by{" "}
      <strong>£{price_increase_by_amount}</strong>. Customers were notified via email on{" "}
      <strong>{p_increase_mail_date}</strong>, and the new price took effect on{" "}
      <strong>{price_increase_schedule_date}</strong>.
    </p>
  ) : (
    <p>
      The subscription price is scheduled to <strong>increase</strong> from <strong>£{original_unit_price}</strong> by{" "}
      <strong>£{price_increase_by_amount}</strong>. Customers will be notified via email on{" "}
      <strong>{p_increase_mail_date}</strong>, and the new price will take effect on{" "}
      <strong>{price_increase_schedule_date}</strong>.
    </p>
  );

  return (
    <div className="card card-custom gutter-b customer-duration">
      <div className="card-header align-items-center border-0 mt-4 mb-0">
        <div className="d-flex justify-content-between w-100">
          <h3 className="card-title align-items-start flex-column">
            <span
              className={`font-weight-bolder ${
                is_price_scheduled ? "text-success" : "text-warning"
              }`}
            >
              {titleText}
            </span>
          </h3>
        </div>
        {paragraphText}
      </div>
    </div>
  );
}
